module.exports = __webpack_public_path__ + "img/新浪.2319776e.png";